type CaretSmallIconProps = {
  direction: 'left' | 'right';
  color: 'purple' | 'gray';
};

function CaretSmallIcon({ direction = 'right', color }: CaretSmallIconProps) {
  const COLORS = {
    purple: 'var(--purple-700)',
    gray: 'var(--gray-400)',
  };

  const path =
    direction === 'right'
      ? 'M17.2959 12.7959L9.7959 20.2959C9.58455 20.5072 9.29791 20.626 8.99902 20.626C8.70014 20.626 8.41349 20.5072 8.20215 20.2959C7.9908 20.0846 7.87207 19.7979 7.87207 19.499C7.87207 19.2001 7.9908 18.9135 8.20215 18.7021L14.9062 12L8.20402 5.2959C8.09937 5.19125 8.01636 5.06702 7.95973 4.93029C7.90309 4.79356 7.87394 4.64702 7.87394 4.49902C7.87394 4.35103 7.90309 4.20448 7.95973 4.06776C8.01636 3.93103 8.09937 3.80679 8.20402 3.70215C8.30867 3.5975 8.4329 3.51449 8.56963 3.45785C8.70636 3.40122 8.8529 3.37207 9.0009 3.37207C9.14889 3.37207 9.29543 3.40122 9.43216 3.45785C9.56889 3.51449 9.69312 3.5975 9.79777 3.70215L17.2978 11.2021C17.4025 11.3068 17.4856 11.4311 17.5422 11.5679C17.5988 11.7047 17.6279 11.8513 17.6277 11.9994C17.6275 12.1475 17.5981 12.2941 17.5412 12.4307C17.4843 12.5674 17.4009 12.6915 17.2959 12.7959Z'
      : 'M6.7041 11.2041L14.2041 3.7041C14.4155 3.49276 14.7021 3.37398 15.001 3.37398C15.2999 3.37398 15.5865 3.49276 15.7978 3.7041C16.0092 3.91545 16.1279 4.2021 16.1279 4.501C16.1279 4.79989 16.0092 5.08654 15.7978 5.29788L9.09375 12L15.7959 18.7041C15.9006 18.8087 15.9836 18.9329 16.0403 19.0697C16.0969 19.2064 16.1261 19.353 16.1263 19.501C16.1265 19.649 16.0971 19.7955 16.0542 19.9322C16.0017 20.0685 15.9187 20.1938 15.814 20.2984C15.7093 20.4031 15.5851 20.4861 15.4484 20.5427C15.3117 20.5993 15.1651 20.6285 15.0171 20.6285C14.8691 20.6285 14.7226 20.5993 14.5859 20.5427C14.4492 20.4861 14.325 20.4031 14.2203 20.2984L6.7041 12.7959C6.59937 12.6912 6.51636 12.567 6.45973 12.4303C6.40309 12.2936 6.37394 12.147 6.37394 11.999C6.37394 11.851 6.40309 11.7045 6.45973 11.5678C6.51636 11.431 6.59937 11.3067 6.7041 11.2041Z';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d={path} fill={COLORS[color]} />
    </svg>
  );
}

export default CaretSmallIcon;
